@if (customHeader) {
  <ng-container
    [ngTemplateOutlet]="customHeader.templateRef"
  ></ng-container>
} @else {
  <div class="modal-header">
    <h4 class="mb-0">
      {{ title | translate }}
    </h4>
    <button
      type="button"
      class="btn-close"
      (click)="close()"
      aria-label="Close"
    ></button>
  </div>
}

@if (customBody) {
  <ng-container
    [ngTemplateOutlet]="customBody.templateRef"
  ></ng-container>
} @else {
  <div class="modal-body text-center">
    <label class="f-18">
      {{ body | translate }}
    </label>
  </div>
}

@if (customFooter) {
  <ng-container
    [ngTemplateOutlet]="customFooter.templateRef"
  ></ng-container>
} @else {
  <div class="modal-footer">
    <button class="btn btn-outline" (click)="close()">
      {{ (!btnCancel ? 'MEMOS.CANCEL' : btnCancel) | translate }}
    </button>
    <button
      class="btn btn-confirm"
      type="button"
      [disabled]="disableBtn"
      [ladda]="laddaLoading"
      (click)="submit()"
    >
      {{ (!btnConfirm ? 'MEMOS.CONFIRM' : btnConfirm) | translate }}
    </button>
  </div>
}
